import { render, staticRenderFns } from "./Play.vue?vue&type=template&id=072ce1e8&scoped=true&"
var script = {}
import style0 from "./Play.vue?vue&type=style&index=0&id=072ce1e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072ce1e8",
  null
  
)

component.options.__file = "Play.vue"
export default component.exports